import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import axisLogo from "../assets/AxisMedia.png";

export default function Footer() {
  const linkClass =
    "text-gray-200 hover:text-white transition duration-200 leading-6";
  const headingClass = "text-lg font-semibold mb-4 text-blue-200";
  const listClass = "space-y-2 text-gray-200 text-sm";

  return (
    <footer
      className="relative text-white overflow-hidden"
      role="contentinfo"
      aria-label="Axis Media Footer"
    >
      {/* ================= BACKGROUND ================= */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#041A3A] via-[#072B55] to-[#0B3F8F]" />
      <div className="absolute -top-20 -right-20 w-[420px] h-[420px] bg-sky-400/20 blur-[180px] rounded-full" />
      <div className="absolute bottom-0 -left-20 w-[380px] h-[380px] bg-indigo-500/20 blur-[200px] rounded-full" />

      {/* ================= CONTENT ================= */}
      <div className="relative z-10 pt-16 pb-10 px-6">
        <div className="max-w-7xl mx-auto grid gap-12 md:grid-cols-2 lg:grid-cols-5">
          {/* ================= BRAND ================= */}
          <div className="max-w-sm lg:col-span-1">
            <NavLink
              to="/"
              aria-label="Axis Media Digital Marketing Agency Home"
              className="inline-flex items-center gap-3"
            >
              <div className="flex items-center justify-start">
                <img
                  src={axisLogo}
                  alt="Axis Media Digital Marketing Agency Logo"
                  loading="lazy"
                  className="h-[150px] w-auto object-contain opacity-90"
                />
              </div>
            </NavLink>

            <p className="text-gray-200 mt-5 leading-relaxed text-[15px]">
              <strong>Axis Media</strong> is a leading
              <strong> digital marketing agency in Delhi NCR</strong>,
              delivering professional SEO services, Google Ads management,
              website development, e-commerce solutions and performance-driven
              online marketing strategies for businesses of all sizes.
            </p>
          </div>

          {/* ================= DIGITAL SERVICES ================= */}
          <nav aria-label="Footer Services">
            <h4 className={headingClass}>Digital Services</h4>
            <ul className={listClass}>
              <li>
                <NavLink to="/digital-marketing" className={linkClass}>
                  Digital Marketing Services
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/digital-marketing-company-in-delhi"
                  className="font-semibold text-sky-300 hover:text-white transition"
                >
                  Digital Marketing Company in Delhi
                </NavLink>
              </li>

              <li>
                <NavLink to="/services" className={linkClass}>
                  All Services
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/website-development" className={linkClass}>
                  Website Development
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/ecommerce-website" className={linkClass}>
                  E-commerce Website
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/branding" className={linkClass}>
                  Branding
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/graphic-design" className={linkClass}>
                  Graphic Design
                </NavLink>
              </li>
              <li>
                <NavLink to="/digital-marketing/seo-optimization" className={linkClass}>
                  SEO Optimization
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/digital-marketing/social-media-marketing"
                  className={linkClass}
                >
                  Social Media Marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="/google-ads" className={linkClass}>
                  Google Ads Management
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* ================= LOCATION SEO PAGES ================= */}
          <nav aria-label="Footer Location Pages">
            <h4 className={headingClass}>Local SEO Pages</h4>
            <ul className={listClass}>
              <li>
                <NavLink to="/seo-services" className={linkClass}>
                  Professional SEO Services
                </NavLink>
              </li>
              <li>
                <NavLink to="/seo-services-delhi" className={linkClass}>
                  SEO Services in Delhi
                </NavLink>
              </li>
              <li>
                <NavLink to="/google-ads-agency-delhi" className={linkClass}>
                  Google Ads Agency in Delhi
                </NavLink>
              </li>
              <li>
                <NavLink to="/website-development-company-delhi" className={linkClass}>
                  Website Development Company in Delhi
                </NavLink>
              </li>
              <li>
                <NavLink to="/social-media-marketing-delhi" className={linkClass}>
                  Social Media Marketing in Delhi
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/digital-marketing-agency-janakpuri"
                  className={linkClass}
                >
                  Digital Marketing Agency in Janakpuri
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={linkClass}>
                  Free Consultation
                </NavLink>
              </li>
              <li>
                <NavLink to="/packages" className={linkClass}>
                  Affordable Packages
                </NavLink>
              </li>
              <li>
                <NavLink to="/grow-business" className={linkClass}>
                  Grow Your Business
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* ================= RESOURCES & INDUSTRIES ================= */}
          <nav aria-label="Business Solutions">
            <h4 className={headingClass}>Resources & Industries</h4>
            <ul className={listClass}>
              <li>
                <NavLink to="/industries" className={linkClass}>
                  Industries We Serve
                </NavLink>
              </li>
              <li>
                <NavLink to="/industries/education" className={linkClass}>
                  Education Marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="/industries/healthcare" className={linkClass}>
                  Healthcare Marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="/industries/real-estate" className={linkClass}>
                  Real Estate Marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="/industries/restaurant" className={linkClass}>
                  Restaurant Marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="/portfolio" className={linkClass}>
                  Our Portfolio
                </NavLink>
              </li>
              <li>
                <NavLink to="/portfolio/puja-portfolio" className={linkClass}>
                  Puja Portfolio
                </NavLink>
              </li>
              <li>
                <NavLink to="/portfolio/foodify-ecommerce" className={linkClass}>
                  Foodify Ecommerce
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className={linkClass}>
                  About Axis Media
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* ================= BLOG + CONTACT ================= */}
          <div>
            <h4 className={headingClass}>Blog & Contact</h4>

            <ul className={`${listClass} mb-6`}>
              <li>
                <NavLink to="/blog" className={linkClass}>
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/blog/best-digital-marketing-agency-in-india"
                  className={linkClass}
                >
                  Best Digital Marketing Agency in India
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/blog/google-ads-for-local-business"
                  className={linkClass}
                >
                  Google Ads for Local Business
                </NavLink>
              </li>
              <li>
                <NavLink to="/blog/seo-vs-google-ads" className={linkClass}>
                  SEO vs Google Ads
                </NavLink>
              </li>
            </ul>

            <h4 className="text-lg font-semibold mb-4 text-blue-200">
              Contact Axis Media
            </h4>

            <p className="text-gray-200 text-sm leading-7">
              <strong>Axis Media</strong>
              <br />
              Digital Marketing Agency
              <br />
              Delhi NCR, India
              <br />
              Working Location: Office No. 820, Jaina Tower-2,
              District Center Janak Puri, Delhi – 110058
            </p>

            <a
              href="mailto:companyaxismedia@gmail.com"
              className="block mt-3 text-gray-200 hover:text-white text-sm transition"
            >
              companyaxismedia@gmail.com
            </a>
            <a
              href="mailto:info@axismediadigital.com"
              className="block mt-2 text-gray-200 hover:text-white text-sm transition"
            >
              info@axismediadigital.com
            </a>

            <a
              href="tel:+919871584001"
              className="block mt-2 text-gray-200 hover:text-white text-sm transition"
            >
              +91 9871584001
            </a>
            <a
              href="tel:+919871147666"
              className="block mt-1 text-gray-200 hover:text-white text-sm transition"
            >
              +91 9871147666
            </a>

            <div className="flex gap-4 mt-6 text-xl text-white">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-300 transition"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.instagram.com/axismedia123"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-300 transition"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61584611262239"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-300 transition"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-300 transition"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-300 transition"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* ================= BOTTOM ================= */}
        <div className="max-w-7xl mx-auto pt-10 mt-10 border-t border-white/20">
          <div className="flex flex-wrap justify-center gap-6 text-gray-300 text-sm">
            <NavLink
              to="/digital-marketing-company-in-delhi"
              className="font-semibold text-sky-300 hover:text-white transition"
            >
              Digital Marketing Company in Delhi
            </NavLink>

            <NavLink to="/sitemap" className="hover:text-white transition">
              HTML Sitemap
            </NavLink>
            <NavLink to="/privacy" className="hover:text-white transition">
              Privacy Policy
            </NavLink>
            <NavLink to="/terms" className="hover:text-white transition">
              Terms of Use
            </NavLink>
            <NavLink to="/accessibility" className="hover:text-white transition">
              Accessibility
            </NavLink>
            <NavLink to="/contact" className="hover:text-white transition">
              Contact
            </NavLink>
          </div>

          <p className="text-center text-gray-300 mt-4 text-sm">
            © {new Date().getFullYear()} <strong>Axis Media</strong>. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}